import { render, staticRenderFns } from "./AddPersonToGroupDialog.vue?vue&type=template&id=3be77d25"
import script from "./AddPersonToGroupDialog.vue?vue&type=script&lang=ts"
export * from "./AddPersonToGroupDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports